export default __webpack_public_path__ + "static/media/chevron-down.97e22754.svg";